module.exports = __webpack_public_path__ + "img/activities-3.de453e71.jpg";